import React, { useEffect, useState } from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { getDay } from '../../sales/reservation/helper/getDay'
import { bannerTypeServices } from 'src/services/reservation/bannerType/BannerType.service'
import { productTypeServices } from 'src/services/reservation/product-type/product_type.service'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()
  const [bannerTypeList, setBannerTypeList] = useState([])
  const [productTypeList, setProductTypeList] = useState([])

  useEffect(() => {
    ;(async () => {
      await Promise.all([
        getBannerTypes(),
        getProductTypes()
      ])
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBannerTypes = async () => {
    try {
      const allBannerTypes = await bannerTypeServices.getByAll({ limit: 999 })
      setBannerTypeList(allBannerTypes)
    } catch (error) {
      setBannerTypeList([])
    }
  }

  const getProductTypes = async () => {
    try {
      const allProducts = await productTypeServices.getByParam()
      setProductTypeList(allProducts)
    } catch (error) {
      setProductTypeList([])
    }
  }

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.entity.banner-type')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.short_name')} value={record.short_name} />
          <ShowListElement label={translate('ra.field.title')} value={record.title} />
          <ShowListElement label={translate('ra.field.description')} value={record.description} />
          <ShowListElement label={translate('ra.field.datetime_from')} value={record?.datetime_from ? getDay(record?.datetime_from, true) : null} />
          <ShowListElement label={translate('ra.field.datetime_to')} value={record?.datetime_to ? getDay(record?.datetime_to, true) : null} />
          <ShowListElement
            label={translate('ra.field.banner_type')}
            value={bannerTypeList.find(elem => elem.id === record.banner_type_id)?.long_name}
          />
          <ShowListElement
            label={translate('ra.field.product_type')}
            value={productTypeList.find(elem => elem.id === record.product_type_id)?.long_name}
          />
          <ShowListElement label={translate('ra.field.flow')} value={record.flow} />
          <ShowListElement label={translate('ra.field.site_type')} value={record.site_type} />
          <ShowListElement label={translate('ra.field.group')} value={record.group} />
          <ShowListElement label={translate('ra.field.order')} value={record.order} />
          <ShowListElement label={translate('ra.field.button_text')} value={record.button_text} />
          <ShowListElement label={translate('ra.field.link')} value={record.link} />
          <ShowListElement label={translate('ra.field.label')} value={record.label} />
          <ShowListElement label={translate('ra.field.category')} value={record.category} />
          <ShowListElement label={translate('ra.field.caption')} value={record.caption} />
          <ShowListElement label={translate('ra.field.currency')} value={record.currency_relation?.long_name} />
          <ShowListElement label={translate('ra.field.amount')} value={record.amount} />
          <ShowListElement label={translate('ra.field.html_content')} value={record.html_content} />
          <ShowListElement label={translate('ra.field.html_content_additional')} value={record.html_content_additional} />
          <ShowListElement label={translate('ra.field.meta')} value={record.meta} />
          <ShowListElement label={translate('ra.field.image')} value={record?.image_url} type='image' />
          <ShowListElement label={translate('ra.field.mobile_image')} value={record?.image_url_mobile} type='image' />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const BannerShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}